export const FETCH_STONETYPE_REQUEST = 'FETCH_STONETYPE_REQUEST';
export const FETCH_STONETYPE_SUCCESS = 'FETCH_STONETYPE_SUCCESS';
export const FETCH_STONETYPE_FAILURE = 'FETCH_STONETYPE_FAILURE';

export const ADD_STONETYPE_REQUEST = 'ADD_STONETYPE_REQUEST';
export const ADD_STONETYPE_SUCCESS = 'ADD_STONETYPE_SUCCESS';
export const ADD_STONETYPE_FAILURE = 'ADD_STONETYPE_FAILURE';

export const UPDATE_STONETYPE_REQUEST = 'UPDATE_STONETYPE_REQUEST';
export const UPDATE_STONETYPE_SUCCESS = 'UPDATE_STONETYPE_SUCCESS';
export const UPDATE_STONETYPE_FAILURE = 'UPDATE_STONETYPE_FAILURE';

export const DELETE_STONETYPE_REQUEST = 'DELETE_STONETYPE_REQUEST';
export const DELETE_STONETYPE_SUCCESS = 'DELETE_STONETYPE_SUCCESS';
export const DELETE_STONETYPE_FAILURE = 'DELETE_STONETYPE_FAILURE';

export const STONETYPE_FORM_ERROR = 'STONETYPE_FORM_ERROR';
export const STONETYPE_FORM_SUCCESS = 'STONETYPE_FORM_SUCCESS';
export const SET_STONETYPE_EDIT = 'SET_STONETYPE_EDIT';
export const CLEAR_STONETYPE_EDIT = 'CLEAR_STONETYPE_EDIT'; 